import { faPen } from "@fortawesome/pro-regular-svg-icons"
import { Skeleton, Typography, useMediaQuery } from "@mui/material"
import theme, { FaIcon } from "@skistarab/mui-theme"

const EDIT_BUTTON_SKELETON = {
  textWidth: 50,
  textHeight: 30,
  mobileIcon: 25,
  tabletIcon: 20,
} as const

type EditButtonProps = {
  isLoading: boolean
  editButtonText: string
}

const EditButton = ({ isLoading, editButtonText }: EditButtonProps) => {
  const isTablet = useMediaQuery(theme.breakpoints.up("md"))

  if (isLoading) {
    return (
      <>
        {isTablet && (
          <Skeleton
            variant="text"
            width={EDIT_BUTTON_SKELETON.textWidth}
            height={EDIT_BUTTON_SKELETON.textHeight}
          />
        )}
        <Skeleton
          variant="circular"
          width={
            isTablet
              ? EDIT_BUTTON_SKELETON.tabletIcon
              : EDIT_BUTTON_SKELETON.mobileIcon
          }
          height={
            isTablet
              ? EDIT_BUTTON_SKELETON.tabletIcon
              : EDIT_BUTTON_SKELETON.mobileIcon
          }
        />
      </>
    )
  }

  return (
    <>
      {isTablet && <Typography variant="button">{editButtonText}</Typography>}
      <FaIcon icon={faPen} sx={{ fontSize: isTablet ? "16px" : "20px" }} />
    </>
  )
}

export default EditButton
